import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import { styled } from '@mui/material';

const Span = styled('span')(({ theme }) => ({
  '&.bold': {
    fontFamily: theme.typography.bold.fontFamily,
  },
}));

const getStyledText = (text) => {
  const textArr = text.split('|*|');
  return textArr.map((textChunk) => {
    const textChunkSplit = textChunk.split('@@');

    if (textChunkSplit.length === 1) {
      return <span key={textChunk}>{textChunk}</span>;
    }
    return (
      <Span key={textChunkSplit[1]} className={clsx(textChunkSplit[0])}>
        {textChunkSplit[1]}
      </Span>
    );
  });
};

const InlineStyledText = ({ text }) => {
  // text with line breaks
  if (text.includes('\n')) {
    // eslint-disable-next-line react/no-array-index-key
    return text.split('\n').map((chunk, index) => <p key={index}>{getStyledText(chunk)}</p>);
  }
  return getStyledText(text);
};

export default InlineStyledText;

InlineStyledText.propTypes = {
  text: string.isRequired,
};
